import React from 'react';
import Article from 'models/articles/Article';
import ArticleCard from 'components/cards/ArticleCard';

const RelatedArticles = ({ articles, title = 'Ostali namigi' }: { articles: Article[]; title?: string }) => {
    return (
        <div className="py-12 bg-gray-200">
            <div className="container">
                <h2>{title}</h2>
                <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 justify-between">
                    {articles.map((article) => {
                        return <ArticleCard article={article} key={article._id} />;
                    })}
                </div>
            </div>
        </div>
    );
};

export default RelatedArticles;
